<template>
    <div class="ppv2-p-6 !ppv2-pr-0 ppv2-h-full">
        <div class="d-flex flex-column flex-md-row align-center justify-space-between">
            <div class="ppv2-flex ppv2-flex-col ppv2-justify-center ppv2-text-black" :style="{ gap: normalizeSize(20, true) }">
                <EnhancementBanner
                    :isVisible="isBannerVisible"
                    :showClose="true"
                    :customDescription="$t('common.enhancement_banner.description_alt')"
                    @close="isBannerVisible = false"
                />
                <div
                    class="ppv2-flex ppv2-flex-col ppv2-justify-center ppv2-text-black"
                    :style="{ gap: normalizeSize(20, true) }"
                >
                    <div
                        class="ppv2-flex ppv2-flex-col ppv2-justify-center ppv2-max-w-[100%] md:ppv2-max-w-[85%] ppv2-mx-auto ppv2-text-black"
                        :style="{ gap: normalizeSize(20, true) }"
                    >
                        <h1 class="poppinsSemiBold" :style="{ fontSize: normalizeFontSize(30) }">
                            {{ $t('available_soon.title') }}
                        </h1>
                        <p class="text-body-1">
                            {{ $t('available_soon.description') }}
                        </p>
                        <v-btn
                            outlined
                            rounded
                            large
                            href="/"
                            class="px-8 ppv2-max-w-[300px] ppv2-border-solid border-purple ppv2-mt-4"
                            style="text-transform: none"
                        >
                            <span class="text-purple">{{ $t('available_soon.back_home') }}</span>
                        </v-btn>
                    </div>
                </div>
            </div>

            <div class="image-content">
                <img src="/media/availableSoon.png" :alt="$t('available_soon.image_alt')" />
            </div>
        </div>
    </div>
</template>

<script>
import normalizeSize from '../../utils/normalizeSize'
import EnhancementBanner from '../Shared/EnhancementBanner.vue'
import normalizeFontSize from '../../utils/normalizeFontSize'

export default {
    name: 'AvailableSoon',
    components: { EnhancementBanner },
    props: ['isNotAvailable'],
    data() {
        return {
            isBannerVisible: false,
        }
    },
    methods: {
        normalizeFontSize,
        normalizeSize,
    },
    mounted() {
        //
    },
}
</script>

<style scoped>
.available-soon-container {
    min-height: 80vh;
    background: linear-gradient(135deg, #f3e7fc 0%, #eef2fd 100%);
}
</style>
